/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import can from 'can';
import _ from 'lodash';
import 'components/leaderboard/statistics/strokes-text/strokes-text';

Component.extend({
    tag: 'leaderboard-missed-fairways',
    template: can.stache(
        '<strokes-text-chart {title}="roundInfo.title" {name}="roundInfo.name" {sub-name}="roundInfo.subName" {modal-title}="roundInfo.name" {description}="roundInfo.description" {rank}="roundInfo.rank" {value}="roundInfo.value" class-name="missed-fairway"></strokes-text-chart>',
    ),
    leakScope: false,
    viewModel: {
        define: {
            round: {
                type: 'number',
            },
            roundInfo: {
                get() {
                    const round = this.attr('round');
                    const obj = round
                        ? this.attr(`player.roundsInfo.${round - 1}.stats`)
                        : this.attr('player.overallStats');
                    const roundsInfo = _.find(obj, (it) =>
                        _.startsWith(it.name, 'Missed Fairway Penalty'),
                    );

                    if (!roundsInfo) {
                        return {
                            name: 'Missed Fairway',
                            subName: 'Penalty (Strokes)',
                            description:
                                'Missed Fairway Penalty is the strokes lost to the player for missing the fairway.',
                            title: 'Strokes',
                        };
                    }

                    return Object.assign({}, roundsInfo, {
                        value: Number(roundsInfo.stat.displayValue).toFixed(2),
                    });
                },
            },
        },
    },
    events: {},
});
